var map = {
	"./+.png": 35513,
	"./+1.png": 8632,
	"./+2.png": 86365,
	"./-.png": 5968,
	"./-1.png": 65222,
	"./-2.png": 92388,
	"./Airdrop.png": 79817,
	"./Airdrop1.png": 63481,
	"./WakumbaAirdrop.png": 58889,
	"./WakumbaAirdrop1.png": 11460,
	"./backtop.png": 92079,
	"./backtop1.png": 39007,
	"./bless-fail.png": 66040,
	"./bless-ok1.png": 48757,
	"./bless-ok2.png": 6002,
	"./btn-stake.png": 51155,
	"./btn-stake1.png": 60326,
	"./btn-unstake.png": 35034,
	"./btn-unstake1.png": 35922,
	"./cancel.png": 17513,
	"./cancel1.png": 12749,
	"./claimSword.png": 83403,
	"./claimSword1.png": 38296,
	"./claimSwordConfirm.png": 46523,
	"./claimSwordConfirmBlue.png": 20162,
	"./claimSwordConfirmHover.png": 82551,
	"./claimSwordIneligible.png": 10413,
	"./claimSwordProcessing.png": 45894,
	"./claimSwordStart.png": 98391,
	"./claimSwordStartHover.png": 20941,
	"./claimSwordSuccessful.png": 26080,
	"./claimUpper.png": 44542,
	"./claimUpper2.png": 86789,
	"./congratulations.png": 66390,
	"./connectWallet.png": 37048,
	"./connectWallet1.png": 32494,
	"./dodoGo.png": 26235,
	"./dodoGo1.png": 61278,
	"./faq.png": 8766,
	"./faq1.png": 65666,
	"./forge/enhance.gif": 21373,
	"./forge/enhance.png": 28098,
	"./forge/enhance1.png": 36110,
	"./forge/popup-applystar/bg.png": 69772,
	"./forge/popup-applystar/btn-apply.png": 81922,
	"./forge/popup-applystar/btn-apply1.png": 8580,
	"./forge/popup-applystar/example.png": 84547,
	"./forge/popup-base/bg.png": 13215,
	"./forge/popup-base/btn-applystar.png": 77531,
	"./forge/popup-base/btn-applystar1.png": 7625,
	"./forge/popup-base/btn-buynow.png": 70573,
	"./forge/popup-base/btn-buynow1.png": 63357,
	"./forge/popup-base/example.jpg": 81377,
	"./forge/popup-base/explains/bg.png": 12438,
	"./forge/popup-base/explains/blue.png": 18859,
	"./forge/popup-base/explains/blue1.png": 60907,
	"./forge/popup-base/explains/enhance.gif": 96891,
	"./forge/popup-base/explains/green.png": 28104,
	"./forge/popup-base/explains/green1.png": 2727,
	"./forge/popup-base/explains/orange.png": 62863,
	"./forge/popup-base/explains/orange1.gif": 27550,
	"./forge/popup-base/explains/orange1.png": 10152,
	"./forge/popup-base/explains/purple.png": 9759,
	"./forge/popup-base/explains/purple1.png": 6815,
	"./forge/popup-base/explains/white.png": 75245,
	"./forge/popup-base/explains/white1.png": 39856,
	"./forge/popup-base/faith.png": 78524,
	"./forge/popup-base/star.png": 7350,
	"./forge/popup-buynow/bg.png": 24743,
	"./forge/popup-buynow/btn-ok.png": 44431,
	"./forge/popup-buynow/btn-ok1.png": 53865,
	"./forge/popup-buynow/example.png": 76518,
	"./forge/popup-buynow/faith-fullname.png": 71165,
	"./forge/popup-buynow/faith.png": 36062,
	"./forge/popup-buynow/star.png": 98828,
	"./forge/swords/blue.png": 51826,
	"./forge/swords/blue1.png": 60900,
	"./forge/swords/example.jpg": 53417,
	"./forge/swords/green.png": 15283,
	"./forge/swords/green1.png": 5948,
	"./forge/swords/orange.png": 19823,
	"./forge/swords/orange1.gif": 15046,
	"./forge/swords/purple.png": 98623,
	"./forge/swords/purple1.png": 99751,
	"./forge/swords/white.png": 14184,
	"./forge/swords/white1.png": 31879,
	"./freeMint.png": 1183,
	"./freeMint1.png": 52594,
	"./gallery.png": 61055,
	"./gallery1.png": 67209,
	"./home.png": 34229,
	"./home1.png": 81868,
	"./mountain/amt1btn.png": 92961,
	"./mountain/amt1btn1.png": 13819,
	"./mountain/amt2btn.png": 81335,
	"./mountain/amt2btn1.png": 94824,
	"./mountain/amt3btn.png": 56762,
	"./mountain/amt3btn1.png": 78773,
	"./mountain/blueVertical.png": 79582,
	"./mountain/blueVertical1.png": 61773,
	"./mountain/freemint-a.png": 90874,
	"./mountain/freemint-a1.png": 56843,
	"./mountain/freemint.png": 5402,
	"./mountain/freemint1.png": 63856,
	"./mountain/greenVertical.png": 50604,
	"./mountain/greenVertical1.png": 97457,
	"./mountain/mint.png": 80767,
	"./mountain/mint1.png": 60163,
	"./mountain/mountain.png": 94670,
	"./mountain/mountain1.png": 20259,
	"./mountain/mountainConnect.png": 73300,
	"./mountain/mountainConnect1.png": 12026,
	"./mountain/mountainNav.gif": 70307,
	"./mountain/orangeVertical.png": 46031,
	"./mountain/orangeVertical1.png": 63497,
	"./mountain/purpleVertical.png": 94483,
	"./mountain/purpleVertical1.png": 5781,
	"./mountain/rewards.png": 94680,
	"./mountain/rewards1.png": 99268,
	"./mountain/summon.png": 82805,
	"./mountain/summon1.png": 81497,
	"./mountain/whiteVertical.png": 12544,
	"./mountain/whiteVertical1.png": 40905,
	"./na.png": 37493,
	"./pray.png": 70781,
	"./pray1.png": 45548,
	"./right.png": 18134,
	"./share.png": 5092,
	"./share/btn-claim.png": 16636,
	"./share/btn-mint.png": 99287,
	"./share/btn-mint1.png": 88204,
	"./share/btn-ok.png": 73945,
	"./share/btn-tw.png": 81434,
	"./share/btn-tw1.png": 6886,
	"./share/mark-await.png": 64834,
	"./share/mark-question.png": 24017,
	"./share/mark-tick.png": 64830,
	"./share/sword-disabled.png": 97387,
	"./share/sword.png": 7481,
	"./share/tab-100.png": 78811,
	"./share/tab-bak.png": 48071,
	"./share/tab.png": 39830,
	"./share1.png": 43198,
	"./staking/btn-stake.png": 30310,
	"./staking/btn-stake1.png": 60116,
	"./staking/btn-unstake.png": 85305,
	"./staking/btn-unstake1.png": 55255,
	"./staking/meditation.gif": 52898,
	"./staking/navi-next.png": 27312,
	"./staking/navi-prev.png": 13570,
	"./staking/tab-staked.png": 47187,
	"./staking/tab-staked1.png": 46382,
	"./staking/tab-unstaked.png": 53541,
	"./staking/tab-unstaked1.png": 52927,
	"./staking/top-claim.png": 99677,
	"./staking/top-claim1.png": 43411,
	"./staking/top-stake.png": 28228,
	"./staking/top-stake1.png": 82668,
	"./staking/top-use.png": 27269,
	"./staking/top-use1.png": 448,
	"./story.png": 49636,
	"./story1.png": 59148,
	"./top-claim.png": 41246,
	"./top-claim1.png": 47881,
	"./top-stake.png": 79947,
	"./top-stake1.png": 51145,
	"./top-use.png": 82356,
	"./top-use1.png": 10278,
	"./twitter.png": 90962,
	"./twitter1.png": 55062,
	"./useUpper.png": 43469,
	"./useUpper2.png": 82607,
	"./viewOnOpensea.png": 25983,
	"./viewOnOpensea1.png": 84920,
	"./wakumba.png": 15523,
	"./wakumba1.png": 35955,
	"./wrong.png": 26627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95019;